import React, { Component } from 'react';
import { Trans } from 'react-i18next';

import Scale from './Scale.jsx';
import Orientation from './Orientation.jsx'
import CellDensity from './CellDensity.jsx';
import Grid from './Grid.jsx';
import Service from './Service.jsx';

import {properties} from '../resources/properties.js';
import i18n from '../resources/i18n';

import IMG_PAISAJE_COLOR from '../img/mapaPosterHorizontal.png';
import IMG_PAISAJE_GRIS from '../img/mapaPosterHorizontalNoSeleccionado.png';
import IMG_RETRATO_COLOR from '../img/mapaPosterVertical.png';
import IMG_RETRATO_GRIS from '../img/mapaPosterVerticalNoSeleccionado.png';

import IMG_COORDENADAS_COLOR from '../img/coordenadas.svg';
import IMG_COORDENADAS_GRIS from '../img/coordenadas-gris.svg';
import IMG_CUADRICULA_COLOR from '../img/cuadricula.svg';
// import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.svg';
import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.png';
import IMG_1KM_COLOR from '../img/Cuadricula_1.svg';
import IMG_1KM_GRIS from '../img/Cuadricula_1-gris.svg';
import IMG_2KM_COLOR from '../img/Cuadricula_2.svg';
import IMG_2KM_GRIS from '../img/Cuadricula_2-gris.svg';
import IMG_5KM_COLOR from '../img/Cuadricula_5.svg';
import IMG_5KM_GRIS from '../img/Cuadricula_5-gris.svg';

declare var M;

class OptionMapSelectorFoto extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstRow: '25K',
      secondRow: '50K',
      activeRow: this.props.activeRow,
      orientation: this.props.orientation,
      orientationIMGPaisajeColor: IMG_PAISAJE_COLOR,
      orientationIMGPaisajeGris: IMG_PAISAJE_GRIS,
      orientationIMGRetratoColor: IMG_RETRATO_COLOR,
      orientationIMGRetratoGris: IMG_RETRATO_GRIS,
      coordinatesIMGColor: IMG_COORDENADAS_COLOR,
      coordinatesIMGGris: IMG_COORDENADAS_GRIS,
      gridIMGColor: IMG_CUADRICULA_COLOR,
      gridIMGGris: IMG_CUADRICULA_GRIS,
      oneKMColor: IMG_1KM_COLOR,
      oneKMGris: IMG_1KM_GRIS,
      twoKMColor: IMG_2KM_COLOR,
      twoKMGris: IMG_2KM_GRIS,
      fiveKMColor: IMG_5KM_COLOR,
      fiveKMGris: IMG_5KM_GRIS,
      radioButtonOneChecked: 'checked',
      radioButtonTwoChecked: 'checked',
      parentState: this.props.parentState
    };
  }

  setStateGlobal = (state, event, value) => {
    const { setParentState } = this.props;
    setParentState(state, event);
  }

  configAutoScale(scale) {
    if (this.props.pluginEdition.currentScale !== scale) {
      this.props.pluginEdition.currentScale = scale;
      window.mapJs.getLayers().filter(l=>(l.legend && l.legend.endsWith('(Líneas)')) || l.impl_.name === '__draw__' || l.from_parameters || l.layerAddedByEditionTools).forEach(l=>l.getFeatures().forEach(f=>{
        f.impl_.olFeature_.changed();
      }));
    }
  }

  changeSelectedScale = (option) => {
    let {parentState} = this.props;

    switch (option) {
      case '2.5K':
        parentState.scale = '1:2.500';
        parentState.cellDensity = "0.5";
        this.configAutoScale(2.5);
        break;
      case '5K':
        parentState.scale = '1:5.000';
        parentState.cellDensity = "0.5";
        this.configAutoScale(5);
        break;
      case '10K':
        parentState.scale = '1:10.000';
        parentState.cellDensity = "1";
        this.configAutoScale(10);
        break;
      default:
        parentState.scale = '1:25.000';
        parentState.cellDensity = "1";
        this.configAutoScale(25);
        break;
    }

    this.props.actionScale(parentState.scale);//, option, parentState.activeRow
    this.setStateGlobal(parentState);
  }

  updateFramesValues = (option) => {
    let {parentState} = this.props;

    if (option === 'gridC') {
      if (parentState.gridFrame === 'active') {
        parentState.gridFrame = '';
      } else {
        parentState.gridFrame = 'active';
      }
    } else if (option === 'cuadriculaC') {
      if (parentState.coordinatesFrame === 'active') {
        parentState.coordinatesFrame = '';
      } else {
        parentState.coordinatesFrame = 'active';
      }
    }
    this.setStateGlobal(parentState);

  }

  changeSelectedOrientation = (option) => {
    let {parentState} = this.props;
    parentState.previousOrientation = parentState.orientation;
    parentState.orientation = option;
    this.setStateGlobal(parentState);
    this.props.actionOrientation(parentState.orientation);
  }

  changeSelectedCellDensity = (option) => {
    let {parentState} = this.props;
    parentState.cellDensity = option;
    this.setStateGlobal(parentState);
  }

  addServiceToMap = (layerName, layerUrl, selected) => {
    let {parentState} = this.props;
    if (!selected){
      window.mapJs.getImpl().getLayers().forEach(layer => {
        if (layer.name === layerName && layer.url === layerUrl) {
          window.mapJs.removeLayers(layer);
        }
      });
      delete parentState.activeServices[layerName];
    } else {
      const newService = new M.layer.WMS({
        url : layerUrl,
        name : layerName,
        legend: layerName,
        tiled: false,
      }, {});
      window.mapJs.addLayers(newService);
      parentState.activeServices[layerName] = layerUrl;
    }
    this.setStateGlobal(parentState);
  }

  render() {

    const {asideClassName, classPanelButton, classPanelContent, parentState} = this.props;
    const {
      orientationIMGPaisajeColor,
      orientationIMGPaisajeGris,
      orientationIMGRetratoColor,
      orientationIMGRetratoGris,
      coordinatesIMGColor,
      coordinatesIMGGris,
      gridIMGColor,
      gridIMGGris,
      oneKMColor,
      oneKMGris,
      twoKMColor,
      twoKMGris,
      fiveKMColor,
      fiveKMGris,
    } = this.state;

    const services = []

    for (let i = 0; i < properties.SERVICE_NAMES.length; i++){
      services.push(
        <React.Fragment key={'service' + i}>
          <li className="serviceElement">
            <Service id={properties.SERVICE_NAMES[i]} label={properties.SERVICE_DISPLAY_NAMES[i]} urlService={properties.SERVICE_URLS[i]}  selected={parentState.activeServices.hasOwnProperty(properties.SERVICE_NAMES[i])} onClick={this.addServiceToMap}/>
          </li>
        </React.Fragment>
      );
    }

    return (<aside className={asideClassName}>
      <div className={classPanelButton}>
        <div className='open'>
          <i className='fas fa-arrow'></i>
        </div>
      </div>
      <div className={classPanelContent}>
        {/* Servicios */}
        <h2 className="h2Custom"><Trans i18nKey="step1.services">Servicios</Trans></h2>
        <div className="scale first-step">

          <div className="radiobutton-row center" >
            <ul>
            {services}
            </ul>
          </div>
        </div>
        {/* ESCALA */}
        <h2 className="h2Custom fullScreenScaleREF"><Trans i18nKey="step1.scale">Escala</Trans></h2>
        <div className="scale second-step fullViewFoto">

          <div className="radiobutton-row center" >

            <Scale scale={parentState.scale} className='small' classNameActive='small active' label='25K' tooltipText='1:25.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='medium-low' classNameActive='medium-low active' label='10K' tooltipText='1:10.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='medium-high' classNameActive='medium-high active' label='5K' tooltipText='1:5.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
            <Scale scale={parentState.scale} className='large' classNameActive='large active' label='2.5K' tooltipText='1:2.500' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>

          </div>
        </div>
        {/* ORIENTACION */}
        <h2 className="h2Custom"><Trans i18nKey="step1.orientation">Orientación</Trans></h2>
        <div className="orientation center third-step">
          <Orientation classNameDiv="horizontal" className="center" src={orientationIMGPaisajeColor} srcChange={orientationIMGPaisajeGris} value={i18n.t('step1.horizontal')} label="Paisaje" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
          <Orientation classNameDiv="vertical" className="center" src={orientationIMGRetratoColor} srcChange={orientationIMGRetratoGris} value={i18n.t('step1.vertical')} label="Retrato" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
        </div>
        {/* CUADRÍCULAS */}
        <h2 className="h2Custom"><Trans i18nKey="step1.grid">Cuadrículas</Trans></h2>

        <div className="orientation center fourth-step">
          <Grid classNameDiv="gridC" className="center" src={gridIMGColor} srcChange={gridIMGGris} label={i18n.t('step1.grid')} checkedI="checked mc-check" selected={parentState.gridFrame} onClick={this.updateFramesValues}/>
          <Grid classNameDiv="cuadriculaC" className="center" src={coordinatesIMGColor} srcChange={coordinatesIMGGris} label={i18n.t('step1.coordinates')} checkedI="checked mc-check" selected={parentState.coordinatesFrame} onClick={this.updateFramesValues}/>
        </div>

        {/* DENSIDAD DE CUADRÍCULA */}
        { this.props.parentState.gridFrame !== '' || this.props.parentState.coordinatesFrame !== '' ? <React.Fragment><h2 className="h2Custom"><Trans i18nKey="step1.cellDimension">Dimensiones de la celda</Trans></h2>

        <div className="orientation center">
          <CellDensity classNameDiv="OneKMC" className="center" src={oneKMColor} srcChange={oneKMGris} value="500 m" label="0.5" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
          <CellDensity classNameDiv="TwoKMC" className="center" src={twoKMColor} srcChange={twoKMGris} value="1 Km" label="1" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
          <CellDensity classNameDiv="FiveKMC" className="center" src={fiveKMColor} srcChange={fiveKMGris} value="2 Km" label="2" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
        </div>
        </React.Fragment> : <React.Fragment />}

      </div>

    </aside>);
  }
}
export default OptionMapSelectorFoto;
